import HashtagLabs from '@/components/HashtagLabs';
import HashtagLabsAd from '@/components/HashtagLabsAd';
import NewsletterPlaceholder from '@/components/NewsletterPlaceholder';
import { Box } from '@mui/material';
import ElementsPageTemplate from '@orgnc/core/components/themes/Elements/components/templates/Page';
import { IPageTemplateProps } from '@orgnc/core/lib/themes/templates/page';

const PageTemplate = ({ page, options }: IPageTemplateProps) => {
  const afterContentSlot = (
    <Box
      sx={{
        '& .newsletter-inject': {
          width: 'auto',
          '@media (max-width: 600px)': {
            '& #newsletter-form-input-container': {
              width: '100%',
            },
            '& .newsletter-input-container': {
              width: '100%',
              flexDirection: 'column',
              gap: '8px',
            },
            '& #newsletter-form': {
              minWidth: 'auto',
              width: '100%',
              '& input': {
                width: '100%',
                marginRight: '0',
              },
              '& button': {
                width: '100%',
                padding: '5px',
              },
            },
          },
        },
      }}
    >
      <NewsletterPlaceholder />
      <HashtagLabsAd unit={'WideBanner_Scroll'} />
    </Box>
  );

  return (
    <>
      <HashtagLabs />
      <HashtagLabsAd
        unit={'WideBanner_Top'}
        sx={{ mt: { xs: 8, lg: 2 }, height: { xs: 100, lg: 250 } }}
      />
      <ElementsPageTemplate
        page={page}
        options={options}
        afterContentSlot={afterContentSlot}
      />
    </>
  );
};

export default PageTemplate;
